import { toUrlParameters } from './util';
import { MessageRemoteRepository } from './message-remote-repository';
import { ConversationRemoteRepository } from './conversation-remote-repository';
export class StateRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async getState() {
        const params = {
            contextId: this.contextId,
            active: true
        };
        const response = await this.fetcher.fetchGetJson(`${StateRemoteRepository.STATE_PATH}?${toUrlParameters(params)}`);
        return this.mapResponseToConversation(response);
    }
    mapResponseToConversation(response) {
        return {
            conversations: response.conversations.map(conversationResponse => ConversationRemoteRepository.mapResponseToConversation(conversationResponse)),
            messages: response.messages.map(messageResponse => MessageRemoteRepository.mapResponseToMessage(messageResponse))
        };
    }
}
StateRemoteRepository.STATE_PATH = '/api/state';
